import axios from '../api/axios';

export async function getCarHouseLogos(carHouseId, options = {}) {
  const response = await axios.get(`/carHouses/${carHouseId}/logos`, options);

  return response.data;
}

export async function assignLogoToCarHouse(carHouseId, logoId) {
  const response = await axios.post(`/carHouses/${carHouseId}/logos/${logoId}`);

  return response.data;
}


export async function deleteCarHouseLogo(carHouseId, logoId) {
  const response = await axios.delete(`/carHouses/${carHouseId}/logos/${logoId}`);
  return response;
}